import { render, staticRenderFns } from "./SaveInstanceModal.vue?vue&type=template&id=35999d8e&"
import script from "./SaveInstanceModal.vue?vue&type=script&lang=js&"
export * from "./SaveInstanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports